import { CustomReport } from "../models/CustomReport";
import { CustomReportField } from "../models/CustomReportField";
import { CustomReportSchema } from "../models/CustomReportSchema";

export class CustomReportsTypeGuardService {

    private static readonly CUSTOMREPORT_TYPES_THAT_SUPPORT_CHILD_CUSTOMREPORTS = [];

    public static isCustomReport(obj: unknown): obj is CustomReport {
        return (
            typeof obj === 'object' &&
            obj !== null &&
            '_type' in obj &&
            typeof (obj as any)._type === 'string'
        );
    }

    public static isCustomReportField(obj: unknown): obj is CustomReportField {
        return (
            typeof obj === 'object' &&
            obj !== null &&
            'name' in obj &&
            'field_type' in obj &&
            typeof (obj as any).name === 'string' &&
            typeof (obj as any).field_type === 'string'
        );
    }

    public static isCustomReportSchema(obj: unknown): obj is CustomReportSchema {
        return (
            typeof obj === 'object' &&
            obj !== null &&
            'type' in obj &&
            'display_name' in obj &&
            'fields' in obj &&
            typeof (obj as any).type === 'string' &&
            typeof (obj as any).display_name === 'string' &&
            Array.isArray((obj as any).fields)
        );
    }

    public static hasDefinedCustomReportSchemaUi(customReportSchema: CustomReportSchema): boolean {
        return this.isCustomReportSchema(customReportSchema)
            && customReportSchema.ui != null
            && typeof customReportSchema.ui === 'object'
            && Array.isArray(customReportSchema.ui.field_groups)
            && customReportSchema.ui.field_groups.length > 0
            && customReportSchema.ui.field_groups.every(group =>
                group != null
                && typeof group === 'object'
                && Array.isArray(group.fields)
                && group.fields.length > 0
            );
    }

    public static supportsChildCustomReports(obj: unknown): boolean {
        return (this.isCustomReport(obj) && this.customReportTypeSupportsChildCustomReports((obj as CustomReport)._type))
            || (this.isPayloadTemplateCustomReportSchema(obj)
                && this.customReportTypeSupportsChildCustomReports((obj as CustomReportSchema).payload_template?.type));
    }

    public static isPayloadTemplateCustomReportSchema(obj: unknown): boolean {
        return this.isCustomReportSchema(obj) && (obj as CustomReportSchema).payload_template != null;
    }

    public static customReportTypeSupportsChildCustomReports(customReportType?: string): boolean {
        return this.CUSTOMREPORT_TYPES_THAT_SUPPORT_CHILD_CUSTOMREPORTS.find(x => customReportType === x) != null;
    }

    public static isNonEmptyCustomReportObject(value: unknown): value is Record<string, unknown> {
        return (
            typeof value === 'object' &&
            value !== null &&
            !Array.isArray(value) &&
            Object.keys(value).length > 0
        )
    }
}
